/**
 * An order's lines as people read them: each item, with the extras chosen for it (the packaging,
 * HQ → Extras) right under it. The storefront puts an extras choice in the cart as its own line; the
 * backend marks it with the item it belongs to (`extra_for`). A line whose item is not found stays a
 * line of its own, so nothing is ever hidden.
 */
export type OrderLine = { id: string; title: string; variant: string | null; quantity: number; unit_price: number; extra_for?: string | null }

export function withExtras<T extends OrderLine>(items: T[]): Array<T & { extras: T[] }> {
  const ids = new Set(items.map((item) => item.id))
  const placed = new Set<string>()
  const out: Array<T & { extras: T[] }> = []
  for (const item of items) {
    if (item.extra_for && ids.has(item.extra_for)) continue
    const extras = items.filter((other) => other.extra_for === item.id)
    extras.forEach((extra) => placed.add(extra.id))
    out.push({ ...item, extras })
  }
  // An extra whose item is missing (should not happen) is shown on its own.
  for (const item of items) if (item.extra_for && ids.has(item.extra_for) && !placed.has(item.id)) out.push({ ...item, extras: [] })
  return out
}

/** «Συσκευασία: Premium (κόκκινο κουτί)» — an extras line in words. */
export const extraLabel = (extra: Pick<OrderLine, "title" | "variant">) => [extra.title, extra.variant].filter(Boolean).join(": ")
